import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=c97c021a&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97c021a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c97c021a')) {
      api.createRecord('c97c021a', component.options)
    } else {
      api.reload('c97c021a', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=c97c021a&scoped=true&", function () {
      api.rerender('c97c021a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22M0Ip99fHjKm/JS/comp/Accordion.vue"
export default component.exports